import { css } from '@emotion/core';

export const icon = css`
  div {
    display: flex;
    flex-shrink: 0;
  }
`;
